<template>
    <div>
        <vs-table @selected="(r) => $emit('selected', r)" max-items="10" search stripe pagination :data="bills">
            <template slot="header">
                <h4> 
                    <strong>Todos os pedidos</strong>
                </h4>
            </template>
            <template slot="thead">
                <!-- <vs-th width="150">PEDIDO</vs-th> -->
                <vs-th sort-key="tableNumber">MESA</vs-th>
                <vs-th sort-key="qtyCustomers" width="50">CLIENTES</vs-th>
                <vs-th sort-key="value">TOTAL</vs-th>
                <vs-th sort-key="openedOn">DATA</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :state="tr.isClosed ? '' : 'danger'" :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td>
                        {{ tr.tableNumber }}
                    </vs-td>    

                    <vs-td class="text-center">
                        {{ tr.qtyCustomers }}
                    </vs-td>

                    <vs-td>
                        {{ tr.value | currency }}
                    </vs-td>

                    <vs-td>
                        {{ tr.openedOn.toDate() | dateFormat('DD/MM/YYYY HH:mm') }}
                    </vs-td>

                </vs-tr>
            </template>
        </vs-table>
        <span v-show="limit === bills.length">Limite de {{ limit }} registros atingido. Refina sua busca</span>
    </div>
</template>

<script>
    export default {
        props: {
            bills: Array,
            limit: Number
        },
    }
</script>

<style lang="scss" scoped>

</style>